var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3431 17.1986L45.5334 6.36841V49.7682H59.9999V25.9921C59.9999 22.6908 58.6834 19.5259 56.3431 17.1986Z",
    fill: "#E4E6EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51577 41.8606L0.343909 20.6463C-0.476283 18.5167 0.584746 16.1246 2.71551 15.304L41.2867 0.446814C43.4162 -0.373378 45.8084 0.687651 46.6286 2.81841L54.8005 24.0327C55.6207 26.1622 54.5596 28.5544 52.4289 29.375L13.8589 44.2322C11.7281 45.0524 9.33715 43.9901 8.51577 41.8606Z",
    fill: "#838EAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5734 10.4607L3.32593 28.3871L6.4054 36.381L52.6549 18.4629L49.5734 10.4607Z",
    fill: "#4C5A81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0671387 27.0353V4.30209C0.0671387 2.01947 1.91791 0.168701 4.20053 0.168701H45.5336C47.8162 0.168701 49.667 2.01947 49.667 4.30209V27.0353C49.667 29.3179 47.8162 31.1687 45.5336 31.1687H4.20053C1.91791 31.1687 0.0671387 29.3179 0.0671387 27.0353Z",
    fill: "#394461"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20044 19.4712H8.33383V21.5379H4.20044V19.4712Z",
    fill: "#E4E6EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20044 23.8451H8.33383V25.9118H4.20044V23.8451Z",
    fill: "#E4E6EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 23.8451H26.9334V25.9118H22.8V23.8451Z",
    fill: "#E4E6EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4001 19.4712H14.5331V21.5379H10.4001V19.4712Z",
    fill: "#E4E6EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5999 19.4712H20.7332V21.5379H16.5999V19.4712Z",
    fill: "#E4E6EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 19.4712H26.9334V21.5379H22.8V19.4712Z",
    fill: "#E4E6EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4336 4.30188H44.5003V7.40192H42.4336V4.30188Z",
    fill: "#E4E6EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2998 4.30188H40.3665V7.40192H38.2998V4.30188Z",
    fill: "#E4E6EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 4.30188H36.2334V7.40192H34.1667V4.30188Z",
    fill: "#E4E6EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0337 4.30188H32.1V7.40192H30.0337V4.30188Z",
    fill: "#E4E6EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4001 49.7689H60V60.102H41.4001V49.7689Z",
    fill: "#445174"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3675 18.8358C36.6148 17.0895 33.7786 17.0946 32.0322 18.8473C30.3436 20.5419 30.285 23.2646 31.8989 25.0308L40.367 34.2688C37.8218 38.7233 37.9305 44.2163 40.649 48.5668L41.4003 49.7686H54.8335V35.3022L38.3675 18.8358Z",
    fill: "#E4E6EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5005 52.8679H46.5672V54.9346H44.5005V52.8679Z",
    fill: "#4C5A81"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99976 12.5996V5.39987C2.99976 4.07381 4.07386 2.99976 5.39999 2.99976H12.6001C13.9262 2.99976 14.9998 4.07381 14.9998 5.39987V12.5996C14.9998 13.9257 13.9262 14.9998 12.6001 14.9998H5.39999C4.07386 14.9998 2.99976 13.9257 2.99976 12.5996Z",
    fill: "#AF8EFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2744 35.6638C54.0007 35.6638 53.6791 35.3237 53.4857 35.1296L49.3523 30.9962C48.9557 30.5861 48.8899 30.156 49.3012 29.7589C49.7022 29.3726 50.098 29.8093 50.4978 30.1957L54.6312 34.3291C55.0342 34.7332 55.2727 34.9506 54.8697 35.3536C54.6752 35.5477 54.5485 35.6638 54.2744 35.6638Z",
    fill: "#4C5A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcards);
export default __webpack_public_path__ + "static/media/creditcards.9a013ee07eee3f5f2d46d2b97bd564c6.svg";
export { ForwardRef as ReactComponent };